import { LoginRequest } from '../../models/login-request.model'
import { LoginResponse } from '../../models/login-response.model'

export class LogIn {
  static readonly type = '[Auth] LogIn'
  constructor(public payload: LoginRequest) {}
}
export class LoggedIn {
  static readonly type = '[Auth] LoggedIn'
  constructor(public response: LoginResponse) {}
}

export class Logout {
  static readonly type = '[Auth] Logout'
}
